import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsYammerComponent } from './simple-icons-yammer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsYammerComponent ],
    exports:      [ SimpleIconsYammerComponent ],
    bootstrap:    []
})
export class SimpleIconsYammerModule {}
